/**
 * Leaf module (no imports back into the page) so UserEditWrapper and UserEditPassword can share the
 * page's includes without importing the EditUserPage config, which renders them (import/no-cycle).
 */
const editUserDefaultIncludes = [
    'roles',
    'buyers',
    'agencies',
    'clients',
    'owners',
    'buyer',
    'agency',
    'client',
    'owner',
    'locale',
    'campaignUser',
];

export default editUserDefaultIncludes;
